import React from 'react';
import {observer} from "mobx-react";
import classNames from "classnames";
import styles from "../../style/prediction.module.scss";

export const PredictionAthleteDetails = observer(({prediction}) => {
  return (
    <div className={classNames(styles.athlete_details)}>
      <div className={classNames(styles.athlete_name)}>{prediction.athlete.name}</div>
      {
        prediction.recordsText
      }
    </div>
  )
});
